import { Component, Input, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { MenuDropdownElemComponent } from '../menu-dropdown-elem/menu-dropdown-elem.component';

@Component({
  selector: 'neo-menu-dropdown-nav',
  templateUrl: './menu-dropdown-nav.component.html',
  styleUrls: ['./menu-dropdown-nav.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MenuDropdownNavComponent implements OnInit {

  @ViewChildren(MenuDropdownElemComponent) menuDropElem: QueryList<MenuDropdownElemComponent>;
  @Input() elementos;
  @Input() principal = true;
  constructor() { }

  ngOnInit(): void {
  }

}
